import {
  getImageUrl,
  processProductAssetsFromContentful,
} from '@components/lib/processProductAssetsFromContentful'
import { mapContentfulImageAsset } from '@utils/contentful/contentfulImage'
import { Asset } from 'contentful'
import React, { FC, useEffect, useState } from 'react'
import ImageGallery from 'react-image-gallery'
import { HiArrowsPointingIn, HiOutlineArrowsPointingOut } from 'react-icons/hi2'

import { HiChevronLeft, HiChevronRight } from 'react-icons/hi'
import { IconButton } from '@noissue-ui-kit/oldBranding/iconButton'
interface IProps {
  className?: string
  children?: any
  images?: Asset[]
  showNav?: boolean
  showFullScreenBtn?: boolean
}

const imageBackgroundColour = '#F7F5F1'

const ProductImageGallery: FC<IProps> = ({
  images,
  showNav = true,
  showFullScreenBtn = false,
}) => {
  const [isFullScreen, setIsFullScreen] = useState(false)
  const containsVideo = images?.some((image) => {
    return image?.fields?.file?.contentType?.indexOf('video') !== -1
  })
  const enableAutoPlay = !containsVideo

  const firstHeroImage = getImageUrl({
    image: mapContentfulImageAsset(images[0]),
    imageBackgroundColour: imageBackgroundColour,
    priority: true,
  })

  const [productImages, setProductImages] = useState<
    {
      renderItem?: () => JSX.Element
      renderThumbInner?: () => JSX.Element
      thumbnail: string
      srcSet?: string
    }[]
  >([firstHeroImage])

  useEffect(() => {
    const loadProductImages = async () => {
      const productImageObjects = await Promise.all(
        images?.map(async (productHeroImage, index) => {
          return await processProductAssetsFromContentful({
            image: mapContentfulImageAsset(productHeroImage),
            imageBackgroundColour: imageBackgroundColour,
            imageIndex: index,
            autoPlay: enableAutoPlay,
          })
        })
      )
      setProductImages(productImageObjects)
    }
    loadProductImages()
  }, [])

  return productImages ? (
    <div
      className={`
      new-image-gallery
      ${isFullScreen ? 'is-full-screen' : ''}
    `}
    >
      <div className="group relative w-full max-h-[100vw] h-[100vw] sm:max-h-[calc(100vh-300px)] lg:max-h-[65vw] xl:max-h-[calc(100vh-140px)]">
        <ImageGallery
          autoPlay={enableAutoPlay}
          slideInterval={enableAutoPlay ? 6000 : 0}
          showFullscreenButton={showFullScreenBtn}
          showPlayButton={false}
          additionalClass={`relative w-full overflow-y-hidden mb-10 xl:mb-0 xl:w-1/2 xl:mr-8 h-full`}
          items={productImages}
          showThumbnails={false}
          lazyLoad={true}
          showBullets={true}
          showNav={showNav}
          onScreenChange={(isFullScreen) => {
            setIsFullScreen(isFullScreen)
          }}
          renderFullscreenButton={(onClick, isFullScreen) => {
            return (
              <button
                className="flex absolute top-5 right-10 z-20 bg-white px-7 py-3 w-auto rounded-full items-center border border-black-40 hover:bg-black-20 active:border-black"
                onClick={onClick}
              >
                {isFullScreen && (
                  <>
                    <HiArrowsPointingIn className="w-8 h-8 text-acai hover:text-acai-120" />
                    <span className="ml-2 text-lg text-acai font-mori leading-none font-semibold mt-1">
                      Close
                    </span>
                  </>
                )}

                {!isFullScreen && (
                  <>
                    <HiOutlineArrowsPointingOut className="w-8 h-8 text-acai hover:text-acai-120" />
                    <span className="ml-2 text-lg text-acai font-mori leading-none font-semibold mt-1">
                      Expand
                    </span>
                  </>
                )}
              </button>
            )
          }}
          renderRightNav={(onClick) => {
            return (
              <IconButton
                size="s"
                onClick={onClick}
                className="flex sm:hidden group-hover:flex absolute top-1/2 -translate-y-1/2 right-10 z-10"
              >
                <HiChevronRight className="w-8 h-8 text-black-80 hover:text-black" />
              </IconButton>
            )
          }}
          renderLeftNav={(onClick) => {
            return (
              <IconButton
                size="s"
                onClick={onClick}
                className="flex sm:hidden group-hover:flex absolute top-1/2 -translate-y-1/2 left-10 z-10"
              >
                <HiChevronLeft className="w-8 h-8 text-acai hover:text-acai-120 text-5xl" />
              </IconButton>
            )
          }}
        />
      </div>
    </div>
  ) : null
}
export default ProductImageGallery
